import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-security-privacy',
  templateUrl: './security-privacy.component.html',
  styleUrls: ['./security-privacy.component.scss'],
  standalone: false,
})
export class SecurityPrivacyComponent {
  constructor(
    protected dialogRef: MatDialogRef<SecurityPrivacyComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public isModal: boolean,
  ) {}
}
